import type { AccessPermission } from "@entrilia/shared/api/types";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import UserContext from "../../../context/UserContext";
import PageContainer from "../../common/PageContainer";
import PageContent from "../../common/PageContent";
import ClientProfilesContent from "./ClientProfilesContent";
import ClientProvisioningContent from "./ClientProvisioningContent";
import CopyCompanyContent from "./CopyCompanyContent";
import DwhSyncContent from "./DwhSyncContent";
import DwhFullSyncContent from "./DwhFullSyncContent";
import OpenFundOpsContent from "./OpenFundOpsContent";
import RenameUserContent from "./RenameUserContent";
import ResetMfaContent from "./ResetMfaContent";
import UserManagementContent from "./UserManagementContent";

interface TabDefinition {
  name: string;
  label: string;
  permissions: AccessPermission[];
  Component: React.ComponentType;
}

const allTabs: TabDefinition[] = [
  {
    name: "client-provisioning",
    label: "Client Provisioning",
    permissions: ["ManageClients"],
    Component: ClientProvisioningContent,
  },
  {
    name: "client-profiles",
    label: "Client Profiles",
    permissions: ["ManageClients"],
    Component: ClientProfilesContent,
  },
  {
    name: "open-fund-ops",
    label: "Open Fund Operations",
    permissions: ["ManageClients"],
    Component: OpenFundOpsContent,
  },
  {
    name: "investor-portal-user-management",
    label: "Investor Portal User Management",
    permissions: ["PerformSystemMaintenance"],
    Component: UserManagementContent,
  },
  {
    name: "client-user-management",
    label: "Client User Management",
    permissions: ["ManageClientUsers"],
    Component: ResetMfaContent,
  },
  {
    name: "rename-user",
    label: "Rename User",
    permissions: ["ManageClientUsers"],
    Component: RenameUserContent,
  },
  {
    name: "dwh-sync",
    label: "DWH Sync",
    permissions: ["PerformSystemMaintenance"],
    Component: DwhFullSyncContent,
  },
  {
    name: "dwh-sync-setup",
    label: "Change DWH Sync Event Hubs",
    permissions: ["PerformSystemMaintenance"],
    Component: DwhSyncContent,
  },
  { name: "copy-company", label: "Copy Company", permissions: ["CopyCompanyData"], Component: CopyCompanyContent },
];

const ClientManagementPage = () => {
  const { permissions } = useDefinedContext(UserContext);

  const visibleTabs = allTabs.filter((tab) => tab.permissions.some((p) => permissions.includes(p)));

  return (
    <PageContainer menuItems={visibleTabs.map(({ name, label }) => ({ name, label }))}>
      {visibleTabs.map((tab) => (
        <PageContent key={tab.name} name={tab.name}>
          <tab.Component />
        </PageContent>
      ))}
    </PageContainer>
  );
};

export default ClientManagementPage;
